import { isEdge } from '../BrowserTest';

export const overflowsX = (
  innerEl: HTMLElement | null,
  outerEl = innerEl
): boolean => {
  if (innerEl === null || outerEl === null) {
    return false;
  }

  const tolerance = isEdge() ? 1 : 0; // Edge rounding workaround; see HubSpot/UIComponents#1711
  const contentWidth: number = innerEl.scrollWidth;
  const containerWidth: number = outerEl.clientWidth;
  return contentWidth > containerWidth + tolerance;
};

export const overflowsY = (
  innerEl: HTMLElement | null,
  outerEl = innerEl
): boolean => {
  if (innerEl === null || outerEl === null) {
    return false;
  }
  const tolerance = isEdge() ? 1 : 0; // Edge rounding workaround; see HubSpot/UIComponents#1711
  const contentHeight: number = innerEl.scrollHeight;
  const containerHeight: number = outerEl.clientHeight;
  return contentHeight > containerHeight + tolerance;
};
